import { FETCH_FAQ, FETCH_LANDING_CONTENT } from './constants'
import { SWAP_LANGUAGE } from '../App/constants'
import { take, call, put, select, fork, takeLatest } from 'redux-saga/effects'
import { apiFetchFAQ } from './services'
import { fetchFAQ, fetchLandingContent } from './actions'
import languages from '../../constants/languages'
import { getOptionFromState } from '../../hocs/OptionsHOC/helpers'
import { slugify } from '../../helpers/utils'

function* fetchFAQWorker({ currentPhoneId, landing = false }) {
  if(!currentPhoneId) return null
  const state = yield select()
  const preSaleFlag = state.devicebits.preSaleFlag
  const language = languages[state.devicebits.language]
  const customer = state.devicebits.customer
  const response = yield call(
    apiFetchFAQ,
    currentPhoneId,
    preSaleFlag,
    language,
    customer
  )

  const faqs = addSlugs(response)

  landing
    ? yield put(fetchLandingContent.success(faqs, currentPhoneId))
    : yield put(fetchFAQ.success(faqs, currentPhoneId))
}

function* fetchFAQWatcher() {
  yield takeLatest(FETCH_FAQ.REQUEST, fetchFAQWorker)
}

function* fetchLandingContentWatcher() {
  yield takeLatest(FETCH_LANDING_CONTENT.REQUEST, fetchFAQWorker)
}

function* languageWatcher() {
  while (true) {
    yield take(SWAP_LANGUAGE)
    const getOption = yield select(getOptionFromState)
    const landingDeviceId = getOption('landing.deviceId')
    yield call(fetchFAQWorker, { currentPhoneId: landingDeviceId, landing: true })
  }
}

export default function* rootSaga() {
  yield fork(fetchFAQWatcher)
  yield fork(fetchLandingContentWatcher)
  yield fork(languageWatcher)
}

const addSlugs = (faqResponse) => {
  const faqs = faqResponse.faqs.map(category => ({
    ...category,
    children: category.children.map(subcat => ({
      ...subcat,
      children: subcat.children.filter(faq => faq.name).map(faq => ({
        ...faq,
        slug: slugify(faq.name)
      }))
    }))
  }))

  return { ...faqResponse, faqs }
}





// WEBPACK FOOTER //
// ./src/containers/FAQs/sagas.js